import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { AdminPanel } from "./AdminPanel";
import ResumeOCR from "./ResumeOCR";
import Upload from "./Upload";
import Login from "./Login";
import  ProcessedResumeOCR  from "./ProcessedResumeOCR";
import Result from "./Result";
import PhotoCrop from "./PhotoCrop";
import { AssignedPDF } from "./AssignedPDF";
import { PreviewDetails } from "./PreviewDetails";
import { AvailablePDF } from "./AvailablePDF";
import AdminLogin from "./AdminLogin";
import { FinalComponent } from "./FinalComponent";
import { FolderData } from "./FolderData";
import FolderLogin from "./FolderLogin";

function App() {
  return (
    <Router>
      <Routes>
        {/* Admin */}
        <Route path="/adminpanel" element={<AdminPanel />} />
        <Route path="/Upload" element={<Upload />} />
        <Route path="/adminp" element={<AdminLogin />} />
        <Route path="/FinalComponent" element={<FinalComponent />} />
        <Route path="/FolderData" element={<FolderData />} />
        <Route path="/FolderLogin" element={<FolderLogin />} />
        {/* user */}
        <Route path="/ResumeOCR" element={<ResumeOCR />} />
        <Route path="/" element={<Login />} />
        <Route path="/ProcessedResumeOCR" element={<ProcessedResumeOCR />} />
        <Route path="/Result" element={<Result />} />
        <Route path="/PhotoCrop" element={<PhotoCrop />} />
        <Route path="/AssignedPDF" element={<AssignedPDF />} />
        <Route path="/AvailabelPDF" element={<AvailablePDF />} />
        <Route path="/PreviewDetails" element={<PreviewDetails />} />
      </Routes>
    </Router>
  );
}

export default App;